import {
	Flex,
	Grid,
	Menu,
	MenuButton,
	MenuItem,
	MenuList,
} from "@chakra-ui/react";
import Logo from "./Logo";
import { Box, Container, Text } from "@chakra-ui/layout";
import SidebarLink from "./SidebarLink";
import HomeIcon from "./icons/HomeIcon";
import TicketIcon from "./icons/TicketIcon";
import BellIcon from "./icons/BellIcon";
import ContactIcon from "./icons/ContactIcon";
import FolderIcon from "./icons/FolderIcon";
import GearIcon from "./icons/GearIcon";
import SidebarFooter from "./SidebarFooter";
import HelpIcon from "./icons/HelpIcon";
import { ArrowUpDownIcon } from "@chakra-ui/icons";
import BuildingIcon from "./icons/BuildingIcon";
import { useCenters } from "../hooks/centers.hooks";
import type { Center } from "../types/center.types";
import DeliveryNoteIcon from "./icons/DeliveryNoteIcon";
import { useNotificationCount } from "../hooks/notifications.hooks";
import CartIcon from "./icons/CartIcon";

function SidebarMember() {
	const { centers, center, setCurrentCenter } = useCenters();
	const { data: stats } = useNotificationCount();

	return (
		<Flex
			w="280px"
			h="100vh"
			bg="zinc.50"
			py="20px"
			direction="column"
			justifyContent="space-between"
			position={"fixed"}
		>
			<Flex h="100%" direction="column" justifyContent="space-between">
				<Container>
					<Flex
						justifyContent="space-between"
						alignItems="center"
						gap="10px"
						ml="10px"
					>
						<Flex alignItems="center" gap="10px">
							<Logo />
							<Text
								fontWeight="700"
								fontSize="20px"
								lineHeight="24px"
								display="inline"
							>
								Supembouts
							</Text>
						</Flex>
						<SidebarLink
							icon={
								<Box position="relative">
									<BellIcon lineHeight="21px" w="21px" h="21px" />
									{stats?.notification.unread !== undefined &&
										stats?.notification.unread !== 0 && (
											<Box
												position="absolute"
												top="-4"
												right="-5"
												backgroundColor="#DC2626"
												color="white"
												borderRadius="100rem"
												w="24px"
												h="24px"
												display="flex"
												justifyContent="center"
												alignItems="center"
											>
												{stats?.notification.unread < 10
													? stats?.notification.unread
													: ""}
											</Box>
										)}
								</Box>
							}
							to="/notifications"
						></SidebarLink>
					</Flex>

					<Box pt={5}>
						<Menu>
							<MenuButton w="100%">
								<Box
									bg="brand.25"
									w="100%"
									border="1px"
									borderColor="gray.200"
									rounded="xl"
									py={2}
								>
									<Flex
										justifyContent="space-between"
										alignItems="center"
										px={3}
									>
										<Flex alignItems="center">
											<Flex
												bg="brand.600"
												borderRadius="40px"
												w="32px"
												h="32px"
												alignItems="center"
												justifyContent="center"
											>
												<BuildingIcon color="white"></BuildingIcon>
											</Flex>
											<Flex direction="column" ml={3}>
												<Text fontWeight={600} fontSize="14px" textAlign="left">
													{center != null && center.name}
													{center === null && <>---</>}
												</Text>
												<Text
													fontWeight={600}
													fontSize="10px"
													color="gray.500"
													textAlign="left"
													textTransform="capitalize"
												>
													{center?.access ?? <>--</>}
												</Text>
											</Flex>
										</Flex>
										<Box>
											<ArrowUpDownIcon></ArrowUpDownIcon>
										</Box>
									</Flex>
								</Box>
							</MenuButton>
							<MenuList>
								{Array.isArray(centers) &&
									centers.map((center: Center) => {
										return (
											<MenuItem
												key={center.id}
												onClick={() => setCurrentCenter(center)}
											>
												{center.name}
											</MenuItem>
										);
									})}
							</MenuList>
						</Menu>
					</Box>

					<Flex direction="column" h="100%" justifyContent="space-between">
						<Box mt="20px">
							<SidebarLink
								icon={<HomeIcon lineHeight="21px" />}
								to="/dashboard"
							>
								Dashboard
							</SidebarLink>
							<SidebarLink icon={<CartIcon lineHeight="21px" />} to="/orders">
								Commandes
							</SidebarLink>
							<SidebarLink
								icon={<DeliveryNoteIcon lineHeight="21px" />}
								to="/orders/deliverynote"
							>
								Bons de livraison
							</SidebarLink>
							<SidebarLink
								icon={<TicketIcon lineHeight="21px" />}
								to="/tickets"
							>
								Ticketing
							</SidebarLink>
							<SidebarLink
								icon={<ContactIcon lineHeight="21px" />}
								to="/patients"
							>
								Patients
							</SidebarLink>
							<SidebarLink
								icon={<FolderIcon lineHeight="21px" />}
								to="/documentation"
							>
								Documentation
							</SidebarLink>
							<SidebarLink icon={<GearIcon lineHeight="21px" />} to="/settings">
								Paramètres
							</SidebarLink>
						</Box>
					</Flex>
				</Container>

				<Box bg="black" color="white" m={3} p={3} rounded="xl">
					<a href="mailto:info@supembouts.fr">
						<Grid gridTemplateRows="1fr 1fr" gridTemplateColumns="2rem 1fr">
							<HelpIcon></HelpIcon>
							<Text fontWeight={600} fontSize="14px" lineHeight="21px">
								Besoin d'aide
							</Text>
							<Box></Box>
							<Text fontWeight={600} fontSize="14px" lineHeight="21px">
								Contactez nous
							</Text>
						</Grid>
					</a>
				</Box>
			</Flex>

			<SidebarFooter />
		</Flex>
	);
}

export default SidebarMember;
